import { Component, OnInit } from '@angular/core';
import { LoadingService } from '../services/loading.service';
import { DataService } from '../services/data.service';

@Component({
  selector: 'app-advanced-search',
  templateUrl: './advanced-search.component.html',
  styleUrls: ['./advanced-search.component.scss']
})
export class AdvancedSearchComponent implements OnInit {

  constructor(
    public loadingSvc: LoadingService,
    public dataSvc: DataService
  ) { }

  ngOnInit() {
  }

    clearFilters() {
    const data = this.dataSvc.searchData;

    Object.keys(data).forEach(key => {
      if (Array.isArray(data[key])) {
        data[key].forEach(item => {
          if (item.value === true) {
            item.value = false;
          }
        });
      }
    });
    this.filtersChanged();
  }

  filtersChanged() {
    clearTimeout(this.dataSvc.syncTimeout);
    clearTimeout(this.dataSvc.searchTimeout);
    
    this.loadingSvc.changeLoading("data.loadFilteredSearchData", true);
    
    this.dataSvc.syncTimeout = setTimeout(() => {
      this.dataSvc.syncFilters();
      this.dataSvc.searchTimeout = setTimeout(async () => {
        await this.dataSvc.applySearch();
        this.dataSvc.syncFilters();
        setTimeout(() => {
          this.loadingSvc.changeLoading("data.loadFilteredSearchData.timeout", false);
        }, 500);
      }, 300);
    }, 200);
  }

}
